export default "__VITE_ASSET__Cp0EZl1i__"